import { Location } from "react-router-dom";

// Threads the deep link a signed-out user originally requested through the
// auth flow — router state for in-app steps (sign-in, MFA), sessionStorage
// across the SSO redirect — so they land back on it once fully authenticated.

const SSO_RETURN_TO_KEY = "sso_return_to";

export const locationToPath = ({ pathname, search, hash }: Location) =>
  `${pathname}${search}${hash}`;

// Only same-app, non-auth paths are safe navigation targets: an absolute URL
// or protocol-relative "//host" must never be honored, and returning into
// /auth/* would loop.
const isSafeReturnTo = (target: unknown): target is string =>
  typeof target === "string" &&
  target.startsWith("/") &&
  !target.startsWith("//") &&
  !target.startsWith("/auth");

export const getReturnTo = (state: unknown): string => {
  const from = (state as { from?: unknown } | null)?.from;

  return isSafeReturnTo(from) ? from : "/";
};

export const storeSSOReturnTo = (state: unknown) => {
  const target = getReturnTo(state);

  // Always overwrite: a leftover target from an abandoned SSO attempt (IdP
  // error, browser Back) must not hijack a later sign-in.
  if (target === "/") {
    sessionStorage.removeItem(SSO_RETURN_TO_KEY);
  } else {
    sessionStorage.setItem(SSO_RETURN_TO_KEY, target);
  }
};

export const takeSSOReturnTo = (): string => {
  const target = sessionStorage.getItem(SSO_RETURN_TO_KEY);
  sessionStorage.removeItem(SSO_RETURN_TO_KEY);

  return isSafeReturnTo(target) ? target : "/";
};
